@if (order$ | async; as order) {
  <div class="row justify-content-end">
    <div class="cx-summary col-sm-12 col-md-6 col-lg-5 col-xl-4">
      <app-custom-order-summary [cart]="order"></app-custom-order-summary>
    </div>
  </div>
}
